(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('PresentListProductDialogController', PresentListProductDialogController);

    PresentListProductDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PresentListProduct', 'Product', 'PresentList'];

    function PresentListProductDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PresentListProduct, Product, PresentList) {
        var vm = this;
        vm.presentListProduct = entity;
        vm.products = Product.query();
        vm.presentlists = PresentList.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:presentListProductUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.presentListProduct.id !== null) {
                PresentListProduct.update(vm.presentListProduct, onSaveSuccess, onSaveError);
            } else {
                PresentListProduct.save(vm.presentListProduct, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
